import { Component , ViewChild} from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Chart } from 'chart.js';
import {GVLogger} from "../../services/gv-logger";
/*
  Generated class for the DashBoard page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-dash-board',
  templateUrl: 'dash-board.html'
})
export class DashBoardPage {

	@ViewChild('barCanvas') barCanvas;
 	@ViewChild('doughnutCanvas') doughnutCanvas;
    @ViewChild('mixedCanvas') mixedCanvas;

    barChart: any;
    doughnutChart: any;
    mixedChart: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, private gVLogger: GVLogger) {}

  ionViewDidLoad() {

  	this.barChart = new Chart(this.barCanvas.nativeElement, {

            type: 'line',
            data: {
                labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange","xyz"],
                datasets: [{
                    label: '# of Votes',
                    data: [50, 19, 30, 15, 2, 10,60],
                    backgroundColor: [
                        'rgba(154,205,50, 0.2)'

                    ],
                    borderColor: [
                        'rgba(255,99,132,1)'

                    ],
                    borderWidth: 1
                }]
            },
            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero:true
                        }
                    }]
                }
            }

        });

          this.gVLogger.log(this.doughnutCanvas);
          var canvasId = 'testCanvas',
          canvas = <HTMLCanvasElement> document.getElementById(canvasId);
         var ctx = canvas.getContext('2d'),
          grd = ctx.createLinearGradient(0, 0, 0, 350);
        grd.addColorStop(0.000, 'rgba(0, 209, 255, 1.000)');
      grd.addColorStop(1.000, 'rgba(250, 251, 253, 1.000)');


  	this.doughnutChart = new Chart(this.doughnutCanvas.nativeElement, {

            type: 'doughnut',
            data: {
                labels: ["Red", "Blue"],
                datasets: [{
                    label: '# of Votes',
                    data: [12, 19],

                    backgroundColor : [
                        'rgba(255, 99, 132, 0.2)',
                        grd
                        //'rgba(255, 255, 255, 0.2)',
                        // 'rgba(255, 206, 86, 0.2)',
                        // 'rgba(75, 192, 192, 0.2)',
                        // 'rgba(153, 102, 255, 0.2)',
                        // 'rgba(255, 159, 64, 0.2)'
                    ],
                    hoverBackgroundColor: [
                        "#FF6384",
                        grd
                        // "#FFCE56",
                        // "#FF6384",
                        // "#36A2EB",
                        // "#FFCE56"
                    ],
                    hoverBorderWidth:1,
                    hoverBorderColor:"#000",
                    tooltips: {
                        enabled: false
                    }
                }],
                options:{
                    onClick: (e)=>{
                        this.gVLogger.log(e);
                        alert(e);
                    }
                }
            }

        });

    this.mixedChart = new Chart(this.mixedCanvas.nativeElement, {

          type: 'bar',
          data: {
            datasets: [{
                  label: 'Bar Dataset',
                  data: [15, 20, 30, 40]
                }, {
                  label: 'Line Dataset',
                  data: [15, 20, 30, 10],

                  // Changes this dataset to become a line
                  type: 'line',
                fill: false,
                lineTension: 0
                }],
            labels: ['January', 'February', 'March', 'April'],
            borderColor:'rgba(255,255,255,1)'

          },
          options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero:true
                        },
                        gridLines: {
                            color: "rgba(0, 0, 0, 0)"
                        }
                    }],
                    xAxes: [{

                        gridLines: {
                            display:false
                        }
                    }]
                }
            }

        });

    this.gVLogger.log('ionViewDidLoad DashBoardPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/dash-board/dash-board.ts